import Camera from "../assets/camera.webp";

export const camera_cards = [
    {
        id: "1",
        image: Camera,
        alt: "Camera Card 1",
        title: "La nostra telecamera",
        description: "Ideali in ogni condizione metereologica e di luce, le telecamere" +
            " che utilizziamo nei nostri campi ci permettono di offrirti la massima qualità al miglior prezzo. " +
            "Riprendi le tue partite in qualsiasi momento con una qualità fino al 4K!",
    },
    {
        id: "2",
        image: Camera,
        alt: "Camera Card 2",
        title: "Lenti a 180 gradi",
        description: "Grazie alla doppia lente delle nostre telecamere, ogni angolo del campo è sotto controllo." +
            " Non ti perderai una singola azione della tua partita!",
    },
    {
        id: "3",
        image: Camera,
        alt: "Camera Card 3",
        title: "Ripresa televisiva",
        description: "Nei campi di calciotto e calcetto, grazie ai nostri modelli AI, seguirai" +
            " la partita come un vero professionista!",
    },
];
